import script from "./TagsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsFilter.vue?vue&type=script&setup=true&lang=js"

import "./TagsFilter.vue?vue&type=style&index=0&id=d9f2fb30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9f2fb30"]])

export default __exports__